const button = () => {
    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('[data-button]').forEach((button) => {
            const hoverListener = () => {
                button.classList.add('button--activate-animation');
                button.removeEventListener('mouseover', hoverListener);
            };
            button.addEventListener('mouseover', hoverListener);
        });
    });
}

export { button }